export default __webpack_public_path__ + "static/media/pianoweb.7c8987d0.png";